var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporateFare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_906_15430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.875V5.625C13.5 4.3875 12.4875 3.375 11.25 3.375H4.5C3.2625 3.375 2.25 4.3875 2.25 5.625V21.375C2.25 22.6125 3.2625 23.625 4.5 23.625H22.5C23.7375 23.625 24.75 22.6125 24.75 21.375V10.125C24.75 8.8875 23.7375 7.875 22.5 7.875H13.5ZM11.25 21.375H4.5V19.125H11.25V21.375ZM11.25 16.875H4.5V14.625H11.25V16.875ZM11.25 12.375H4.5V10.125H11.25V12.375ZM11.25 7.875H4.5V5.625H11.25V7.875ZM22.5 21.375H13.5V10.125H22.5V21.375ZM20.25 12.375H15.75V14.625H20.25V12.375ZM20.25 16.875H15.75V19.125H20.25V16.875Z",
    fill: "#3C9718"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_906_15430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateFare);
export default __webpack_public_path__ + "static/media/corporate_fare.03fcf9b63eb48885f28bcf2e2eebf119.svg";
export { ForwardRef as ReactComponent };